import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/content/schemas")({
  component: () => (
    <Breadcrumb label="Schemas" to="/content/schemas">
      <Outlet />
    </Breadcrumb>
  ),
});
